import { graphql } from 'react-relay';

export const tradeGeneralOnboardingQuery = graphql`
    query tradeGeneralOnboardingQuery($userId: String!) {
        viewer {
            isTradeGeneralOnboardingDisabled: isEnabled(key: "disableTradeGeneralOnboarding")
            user(userId: $userId) {
                verifiedTradeSubStatus
            }
        }
    }
`;
